/** Variacion porcentual con flecha y color semantico (design.md §22.7). */
import { clsx } from 'clsx';
import { MobileIcon } from './MobileIcon';

type TrendDirection = 'up' | 'down';

type TrendBadgeProps = {
  direction: TrendDirection;
  value: number;
  className?: string;
};

const directionStyles: Record<TrendDirection, string> = {
  up: 'bg-success-light text-success-dark',
  down: 'bg-error-light text-error-dark',
};

export function TrendBadge({ direction, value, className }: TrendBadgeProps) {
  const spoken = `${direction === 'up' ? 'sube' : 'baja'} ${value}%`;
  return (
    <span
      className={clsx(
        'inline-flex shrink-0 items-center gap-1 rounded-full px-2 py-0.5 text-xs font-semibold',
        directionStyles[direction],
        className,
      )}
    >
      <MobileIcon
        name={direction === 'up' ? 'trending_up' : 'trending_down'}
        className="h-3.5 w-3.5"
      />
      <span className="sr-only">{spoken}</span>
      <span aria-hidden="true" className="tabular-nums">{value}%</span>
    </span>
  );
}
